import { render } from "./GameSession.vue?vue&type=template&id=2c45ed74"
import script from "./GameSession.vue?vue&type=script&lang=js"
export * from "./GameSession.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__